import React from 'react';

export default class NumberInput extends React.Component {

  constructor(props) {
    super();
    let divClassName = 'number-input';
    let inputClassName = 'number-input__input';
    let labelClassName = 'number-input__label';
    let defaultValue = 0;
    let value = null;
    let minValue = -2147483646;
    let maxValue = 2147483647;
    let name = '';
    let step = 1;
    let label = '';
    let id = null;
    let allowEmpty = false;
    let placeholder = null;
    let callback = null;
    let fixed = false;
    let fixedNumber = 0;
    let hideArrows = false;
    let runOnActualChange = false;
    let onFocus = () => {
    };
    let onBlur = () => {
    };

    if (props.divClass) {
      divClassName += ` ${props.divClass}`;
    }

    if (props.allowEmpty) {
      allowEmpty = props.allowEmpty;
    }

    if (props.placeholder) {
      placeholder = props.placeholder;
    }

    if (props.runOnActualChange) {
      runOnActualChange = true;
    }

    if (props.labelClass) {
      labelClassName += ` ${props.labelClass}`;
    }

    if (props.step) {
      step = parseFloat(props.step);
    }

    if (props.label) {
      label = props.label;
    }

    if (props.id) {
      id = props.id;
    }

    if (props.fixed) {
      fixed = true;
      fixedNumber = props.fixed;
    }
    if (props.hideArrows) {
      hideArrows = props.hideArrows;
    }

    if (props.inputClass) {
      inputClassName += ` ${props.inputClass}`;
    }
    if (props.maxValue !== null) {
      maxValue = parseInt(props.maxValue);
    }
    if (props.minValue !== null) {
      minValue = parseInt(props.minValue);
    }

    if (props.defaultValue || props.defaultValue === '0' || props.defaultValue === 0) {
      defaultValue = parseFloat(props.defaultValue).toFixed(2);
      if (props.integersOnly === true) {
        defaultValue = parseInt(props.defaultValue);
      }
    }

    if (props.value || props.value === '0' || props.value === 0) {
      value = parseInt(props.value);
    }

    if (props.defaultValue === '') {
      defaultValue = '';
      value = null;
    }

    if (props.name) {
      name = props.name;
    }
    if (props.callback) {
      callback = props.callback;
    }
    if (props.onFocus) {
      onFocus = props.onFocus;
    }
    if (props.onBlur) {
      onBlur = props.onBlur;
    }

    this.state = {
      ...props,
      divClassName,
      inputClassName,
      label,
      value: defaultValue || ((value === null) ? '' : (value === null || value === '' ? ((minValue === null || defaultValue === 0 || minValue <= defaultValue) ? this.trimAfterDecimal(defaultValue, fixedNumber) : this.trimAfterDecimal(minValue, fixedNumber)) : value)),
      maxValue,
      name,
      fixedNumber,
      placeholder,
      fixed,
      step,
      runOnActualChange,
      id,
      labelClassName,
      hideArrows,
      minValue,
      allowEmpty,
      callback,
      onFocus,
      onBlur
    };
    this.inputRef = React.createRef();
    this.boundCheckValue = this.checkValue.bind(this);
  }

  componentWillReceiveProps(props) {
    if (props.value || props.value === 0) {
      this.setState({
        value: this.trimAfterDecimal(props.value)
      });
    }
  }

  /**
   *
   * @param _newValue
   * @param fixedNumber ONLY USED IN CONSTRUCTOR!
   * @returns {*}
   */
  trimAfterDecimal(_newValue, fixedNumber = false) {
    let newValue = _newValue;
    //force it to be a float
    newValue = parseFloat(newValue.toString());
    if (fixedNumber !== false || (this.state && this.state.fixed)) {
      return newValue.toFixed((fixedNumber === false ? this.state.fixedNumber : fixedNumber));
    }
    if (this.props.integersOnly) {
      newValue = Math.round(newValue);
    }
    return newValue;
  }

  checkValue(e, overrideValue = null) {

    if (this.state.allowEmpty && e.target.value === '') {
      this.runCallback('');
      return;
    }

    let newValue = overrideValue;

    if (!e && overrideValue === null) {
      newValue = this.state.step;
    }

    if (newValue === null) {
      try {
        newValue = parseFloat(e.target.value);
        if (isNaN(newValue)) {
          newValue = 0;
        }
      } catch (parseException) {
        console.warn(parseException);
      }
    }

    if ((newValue < this.state.minValue && this.state.minValue !== null)) {
      newValue = parseFloat(this.state.minValue);
      if (this.state.fixed) {
        newValue = newValue.toFixed(this.state.fixedNumber);
      }
    }

    if ((newValue > this.state.maxValue && this.state.maxValue !== null)) {
      newValue = parseFloat(this.state.maxValue);
      if (this.state.fixed) {
        newValue = newValue.toFixed(this.state.fixedNumber);
      }
    }

    newValue = this.trimAfterDecimal(newValue);

    this.setState({
      value: newValue
    });

    this.runCallback(newValue);
  }

  runCallback(value) {
    if (this.state.callback !== null) {
      this.state.callback(value);
    }
  }

  handleButtonPress(up = true) {
    return function (e) {

      let newValue = 0;
      try {
        newValue = parseFloat(this.state.value);
      } catch (parseException) {
        console.warn(parseException);
      }

      newValue = (up ? newValue + this.state.step : newValue - this.state.step);
      newValue = this.trimAfterDecimal(newValue);

      this.setState({
        value: newValue
      });


      this.checkValue(null, (isNaN(newValue) ? null : newValue));
    };
  }

  render() {
    return (
      <div className={this.state.divClassName}>
        <label htmlFor={this.state.id} className={this.state.labelClassName}>{this.state.label}</label>
        <div style={{position: 'relative'}}>
          <input className={this.state.inputClassName}
                 ref={this.inputRef}
                 id={this.state.id}
                 placeholder={this.state.placeholder}
                 name={this.state.name}
                 onBlur={(e) => {
                   this.boundCheckValue(e);
                   this.setState({currentlyFocused: false});
                   this.state.onBlur();
                 }}
                 onFocus={() => {
                   this.state.onFocus();
                   this.setState({currentlyFocused: true});
                 }}
                 value={this.state.value}
                 step={this.state.step}
                 onChange={e => {
                   if (this.state.runOnActualChange) {
                     if (e.target.value === '' || e.target.value === null) {
                       this.setState({value: e.target.value});
                       this.runCallback('');
                       return;
                     }
                     this.checkValue(e);
                     return;
                   }
                   this.setState({value: e.target.value});
                 }} type={'number'}/>
          {this.state.hideArrows ? null : <div className={'number-input__button --up'}
                                               onClick={this.handleButtonPress(true).bind(this)}/>}
          {this.state.hideArrows ? null : <div className={'number-input__button --down'}
                                               onClick={this.handleButtonPress(false).bind(this)}/>}
        </div>
      </div>
    );
  }
}
